var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-right" },
    [
      _vm._v(" info "),
      _c(
        "b-button",
        {
          staticClass: "btn-icon rounded-circle mt-1",
          attrs: { size: "sm", id: "popover-rol", variant: "flat-primary" }
        },
        [_c("feather-icon", { attrs: { icon: "InfoIcon" } })],
        1
      ),
      _c(
        "b-popover",
        {
          attrs: { target: "popover-rol", triggers: "focus", placement: "top" },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [_c("span", [_vm._v("Tipos de roles!")])]
              },
              proxy: true
            }
          ])
        },
        [
          _c("span", [
            _c("b", [_vm._v("+ Aprobador:")]),
            _vm._v(
              " es aquel que aprobará o rechazará el flujo. Cabe destacar que si se rechaza el flujo este termina, sin importar si existen pasos posteriores a este, mientras que si aprueba continúa con los pasos posteriores, en caso de que estos existan, o bien, termina el flujo. "
            ),
            _c("br"),
            _c("b", [_vm._v("+ Revisor:")]),
            _vm._v(
              " es aquel usuario que se encarga de revisar. Cabe destacar que puede aprobar o rechazar el flujo, sin embargo, dicha acción es simplemente informativa. "
            ),
            _c("br"),
            _c("b", [_vm._v("+ Firmante:")]),
            _vm._v(
              " es aquel que firmará el documento del flujo, aprobando este mismo, o bien, rechazará el documento del flujo. Cabe destacar que si se rechaza el flujo este termina, sin importar si existen pasos posteriores a este, mientras que si firma continúa con los pasos posteriores, en caso de que estos existan, o bien, termina el flujo. "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }